// AI模型API服务

// 多个OpenRouter API Keys配置
const API_KEYS = [
  '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',
  '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',
  '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',
  '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',
  'sk-or-v1-1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2',
  'sk-or-v1-a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1',
  'sk-or-v1-f9e8d7c6b5a4f3e2d1c0b9a8f7e6d5c4b3a2f1e0d9c8b7a6f5e4d3c2b1a0f9',
  'sk-or-v1-d1c2b3a4e5f6d7c8b9a0e1f2d3c4b5a6e7f8d9c0b1a2e3f4d5c6b7a8e9f0d1',
  'sk-or-v1-b7a6c5d4e3f2b1a0c9d8e7f6b5a4c3d2e1f0b9a8c7d6e5f4b3a2c1d0e9f8b7',
  'sk-or-v1-e3f4d5c6b7a8e9f0d1c2b3a4e5f6d7c8b9a0e1f2d3c4b5a6e7f8d9c0b1a2e3'
];

// OpenRouter API配置
const API_CONFIG = {
  apiUrl: 'https://openrouter.ai/api/v1',
  forceRealApiCall: true, // 保持强制使用API调用
  minApiCallTime: 2000 // 最小API调用时间（毫秒），用于验证真实调用
};

// 模型配置
const MODELS = {
  primary: "qwen/qwen3-1.7b:free",
  backup: [
    "openai/gpt-4o-mini",
    "anthropic/claude-3-haiku",
    "mistralai/mistral-7b-instruct"
  ]
};

// 记录API调用状态
let lastApiCallTime = 0;
let apiCallCount = 0;
let apiCallSuccess = false;
let apiCallInProgress = false;

// 获取当前要使用的API Key索引
const getCurrentKeyIndex = () => {
  const savedIndex = localStorage.getItem('currentApiKeyIndex');
  return savedIndex ? parseInt(savedIndex) : 0;
};

// 更新API Key索引到下一个
const updateKeyIndex = (currentIndex) => {
  const nextIndex = (currentIndex + 1) % API_KEYS.length;
  localStorage.setItem('currentApiKeyIndex', nextIndex.toString());
  return nextIndex;
};

// 添加API请求超时控制
const fetchWithTimeout = async (url, options, timeout = 30000) => {
  const controller = new AbortController();
  const { signal } = controller;

  const timeoutId = setTimeout(() => controller.abort(), timeout);
  
  try {
    // 增加统计
    apiCallCount++;
    lastApiCallTime = Date.now();
    apiCallInProgress = true;
    
    // 在浏览器控制台明确标记API调用
    console.log(`%c实际执行API请求: ${url}`, 'background: #4CAF50; color: white; padding: 2px 5px; border-radius: 2px;');
    console.log('请求头:', options.headers);
    console.log('请求体:', options.body);
    
    const response = await fetch(url, { ...options, signal });
    
    // 记录成功调用
    if (response.ok) {
      apiCallSuccess = true;
      console.log(`%cAPI请求成功: ${response.status}`, 'background: #4CAF50; color: white; padding: 2px 5px; border-radius: 2px;');
    } else {
      console.log(`%cAPI请求失败: ${response.status}`, 'background: #f44336; color: white; padding: 2px 5px; border-radius: 2px;');
    }
    
    clearTimeout(timeoutId);
    apiCallInProgress = false;
    return response;
  } catch (error) {
    console.log(`%cAPI请求异常: ${error.message}`, 'background: #f44336; color: white; padding: 2px 5px; border-radius: 2px;');
    clearTimeout(timeoutId);
    apiCallInProgress = false;
    throw error;
  }
};

// 使用QuestionAnalyzer作为本地后备方案 - 仅在API彻底失败后使用
const getLocalFallbackResponse = (question, puzzleContent) => {
  // 完全禁止在未发送API请求时使用本地回退
  if (API_CONFIG.forceRealApiCall && apiCallCount === 0) {
    throw new Error('必须进行API调用，不允许使用本地回退');
  }
  
  // 只有在确实尝试过API调用后才允许回退
  if (API_CONFIG.forceRealApiCall && !apiCallSuccess && apiCallCount < 1) {
    throw new Error('必须成功进行至少一次API调用，不允许使用本地回退');
  }
  
  try {
    const QuestionAnalyzer = require('../utils/questionAnalyzer').default;
    const analyzer = new QuestionAnalyzer({ content: puzzleContent || '' });
    const result = analyzer.analyzeQuestion(question);
    console.log('使用本地后备分析器生成回答:', result);
    return result.answer || '是又不是';
  } catch (error) {
    console.error('本地后备分析失败:', error);
    return '是又不是';
  }
};

// 验证API调用是否真实发生
const validateApiCall = (startTime) => {
  const callDuration = Date.now() - startTime;
  if (callDuration < API_CONFIG.minApiCallTime) {
    console.warn(`%cAPI调用时间异常短 (${callDuration}ms < ${API_CONFIG.minApiCallTime}ms)，可能未真正调用API`, 'background: #FF9800; color: white; padding: 2px 5px; border-radius: 2px;');
    apiCallSuccess = false; // 认为没有成功调用API
    return false;
  }
  return true;
};

// 使用Qwen 3模型的AI响应函数
export const getAIResponse = async (question) => {
  // 重置API调用状态
  apiCallCount = 0;
  apiCallSuccess = false;
  lastApiCallTime = 0;
  apiCallInProgress = false;
  
  console.log('准备调用API，问题:', question);
  
  // 获取当前API Key索引
  let currentKeyIndex = getCurrentKeyIndex();
  let apiKey = API_KEYS[currentKeyIndex];
  
  // 添加调试计时日志
  const startTime = Date.now();
  console.log(`API调用开始时间: ${startTime.toISOString()}`);
  console.log(`使用API Key索引: ${currentKeyIndex}, Key: ${apiKey.substring(0, 8)}...`);
  
  try {
    // 获取当前谜题内容，用于提供上下文
    let puzzleContent = '';
    
    try {
      // 尝试从localStorage获取当前谜题内容
      const currentPuzzle = localStorage.getItem('currentPuzzle');
      if (currentPuzzle) {
        const puzzleData = JSON.parse(currentPuzzle);
        puzzleContent = puzzleData.content || '';
        console.log('成功获取谜题内容:', puzzleContent.substring(0, 50) + '...');
      }
    } catch (e) {
      console.error('无法获取谜题内容:', e);
    }
    
    // 构建包含谜题内容的系统提示
    const systemPrompt = `你是海龟汤游戏的AI回答者。你的回答必须符合以下规则：

1. 你只能回答"是"、"不是"或"是又不是"这三种答案之一
2. 不要给出任何解释，只提供这三个词之一
3. 你必须基于下面提供的海龟汤谜题内容来回答
4. 你的回答必须保持逻辑一致性，例如：
   - 如果"有人死了"的答案是"是"，那么"没有人死"的答案必须是"不是"
   - 如果"是X"的答案是"是"，那么"不是X"的答案必须是"不是"
   - 避免自相矛盾的回答

海龟汤谜题内容：${puzzleContent}`;

    // 尝试主模型和备用模型
    let modelToUse = MODELS.primary;
    let modelAttempt = 0;
    let modelSuccess = false;
    let finalAnswer = null;
    
    // 最多尝试主模型+3个备用模型
    while (!modelSuccess && modelAttempt <= MODELS.backup.length) {
      if (modelAttempt > 0) {
        // 切换到备用模型
        modelToUse = MODELS.backup[modelAttempt - 1];
        console.log(`切换到备用模型: ${modelToUse}`);
      }
    
      // 使用选定的模型
      const requestBody = {
        model: modelToUse,
        messages: [
          {
            role: "system",
            content: systemPrompt
          },
          {
            role: "user",
            content: question
          }
        ],
        temperature: 0.2,  // 降低温度，使输出更确定性
        max_tokens: 20     // 限制输出长度，只需要短答案
      };
      
      console.log(`发送API请求到模型: ${modelToUse}...`);
      
      // 在浏览器控制台清晰显示这次请求
      console.log('%c准备发送API请求', 'background: #2196F3; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;');
      console.log('请求体:', JSON.stringify(requestBody, null, 2));
      
      // 确保实际发送请求
      console.log('正在等待API响应...');
      
      // 如果是第一个模型，使用更长的延时
      if (modelAttempt === 0) {
        await new Promise(resolve => setTimeout(resolve, 2000));
      } else {
        // 对备用模型使用较短的延迟
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      
      // 尝试API调用，有最多重试3次的机会
      let response = null;
      let success = false;
      let retryCount = 0;
      
      // 记录API调用开始时间
      const apiCallStartTime = Date.now();
      
      // 开始请求重试循环
      while (!success && retryCount < 3) {
        try {
          // 执行fetch请求，添加超时控制
          console.log(`%c正在执行API请求 (尝试 ${retryCount + 1}/3)`, 'color: #2196F3; font-weight: bold;');
          
          response = await fetchWithTimeout(
            `${API_CONFIG.apiUrl}/chat/completions`, 
            {
              method: "POST",
              headers: {
                "Authorization": `Bearer ${apiKey}`,
                "Content-Type": "application/json",
                "HTTP-Referer": window.location.origin,
                "X-Title": "海龟汤游戏"
              },
              body: JSON.stringify(requestBody)
            },
            20000 // 20秒超时
          );
          
          // 验证API调用是否真实发生
          const isValidCall = validateApiCall(apiCallStartTime);
          
          if (response.ok && isValidCall) {
            success = true;
            console.log(`%cAPI请求成功!`, 'background: #4CAF50; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;');
          } else {
            if (!isValidCall) {
              console.error('API调用时间异常短，认为是假调用');
            }
            
            // 如果请求失败，尝试下一个API Key
            console.warn(`API Key ${currentKeyIndex} 请求失败，状态码: ${response?.status || 'unknown'}`);
            
            // 尝试获取错误响应体
            if (response) {
              try {
                const errorData = await response.json();
                console.error('API错误详情:', errorData);
              } catch (e) {
                console.error('无法解析错误响应');
              }
            }
            
            currentKeyIndex = updateKeyIndex(currentKeyIndex);
            apiKey = API_KEYS[currentKeyIndex];
            console.log(`切换到API Key索引: ${currentKeyIndex}, Key: ${apiKey.substring(0, 8)}...`);
            retryCount++;
            
            // 在重试前添加短暂延迟
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
        } catch (fetchError) {
          console.error('Fetch错误:', fetchError);
          
          // 如果是超时错误，记录特定信息
          if (fetchError.name === 'AbortError') {
            console.error('API请求超时');
          }
          
          // 如果网络错误，尝试下一个API Key
          currentKeyIndex = updateKeyIndex(currentKeyIndex);
          apiKey = API_KEYS[currentKeyIndex];
          console.log(`切换到API Key索引: ${currentKeyIndex}, Key: ${apiKey.substring(0, 8)}...`);
          retryCount++;
          
          // 在重试前添加短暂延迟
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
      
      if (success) {
        try {
          // 解析响应JSON
          const data = await response.json();
          console.log('API完整响应:', data);
          
          // 提取回答内容
          if (data && data.choices && data.choices[0] && data.choices[0].message) {
            const answer = data.choices[0].message.content.trim().toLowerCase();
            console.log(`模型 ${modelToUse} 成功返回答案:`, answer);
            
            // 将API响应限制为三种可能的答案
            if (answer.includes('是又不是')) {
              finalAnswer = '是又不是';
            } else if (answer.includes('不是')) {
              finalAnswer = '不是';
            } else if (answer.includes('是')) {
              finalAnswer = '是';
            } else {
              // 如果无法确定，保持为null以尝试下一个模型
              finalAnswer = null;
            }
            
            // 如果获得了有效答案，标记成功并结束循环
            if (finalAnswer) {
              modelSuccess = true;
              apiCallSuccess = true; // 确保标记成功调用
              break;
            }
          }
        } catch (parseError) {
          console.error('解析响应时出错:', parseError);
        }
      }
      
      // 当前模型尝试结束，尝试下一个模型
      modelAttempt++;
    }
    
    const endTime = Date.now();
    const duration = (endTime - startTime) / 1000;
    console.log(`API请求完成，耗时: ${duration}秒`);
    
    // 如果所有模型都失败或者没有得到有效答案，使用本地分析器
    if (!modelSuccess || !finalAnswer) {
      console.error('所有API模型尝试均失败，使用本地分析器');
      
      // 如果没有实际发送过API请求且强制使用API，则抛出错误
      if (API_CONFIG.forceRealApiCall && apiCallCount === 0) {
        throw new Error('未能发送API请求，请检查网络连接');
      }
      
      // 使用问题分析器作为后备方案生成答案
      finalAnswer = getLocalFallbackResponse(question, puzzleContent);
    }
    
    // 记录API调用统计信息
    console.log(`API调用统计: 调用次数=${apiCallCount}, 最后调用时间=${new Date(lastApiCallTime).toISOString()}, 成功=${apiCallSuccess}`);
    
    return finalAnswer;
  } catch (error) {
    console.error('API调用出错:', error);
    
    // 检查是否强制使用API但未发送请求
    if (API_CONFIG.forceRealApiCall && !apiCallSuccess) {
      // 尝试最后一次调用API
      try {
        console.log('%c尝试最后一次强制API调用', 'background: #FF9800; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;');
        
        const fallbackRequestBody = {
          model: "mistralai/mistral-7b-instruct", // 使用更可靠的模型
          messages: [
            {
              role: "user",
              content: `回答这个问题，必须只使用"是"、"不是"或"是又不是"中的一个: ${question}`
            }
          ],
          temperature: 0.1,
          max_tokens: 10
        };
        
        const apiCallStartTime = Date.now();
        
        const response = await fetchWithTimeout(
          `${API_CONFIG.apiUrl}/chat/completions`,
          {
            method: "POST",
            headers: {
              "Authorization": `Bearer ${API_KEYS[0]}`,
              "Content-Type": "application/json",
              "HTTP-Referer": window.location.origin
            },
            body: JSON.stringify(fallbackRequestBody)
          },
          10000
        );
        
        // 验证API调用是否真实发生
        const isValidCall = validateApiCall(apiCallStartTime);
        
        if (response.ok && isValidCall) {
          const data = await response.json();
          if (data && data.choices && data.choices[0] && data.choices[0].message) {
            const answer = data.choices[0].message.content.trim().toLowerCase();
            console.log('最后尝试获得回答:', answer);
            apiCallSuccess = true;
            
            if (answer.includes('是又不是')) return '是又不是';
            if (answer.includes('不是')) return '不是';
            if (answer.includes('是')) return '是';
          }
        } else {
          console.error('最后API调用验证失败，调用时间过短或状态码错误');
        }
      } catch (finalError) {
        console.error('最终API尝试也失败:', finalError);
      }
    }
    
    // 检查API调用成功与否
    if (!apiCallSuccess && API_CONFIG.forceRealApiCall) {
      console.error('未能成功调用API，返回默认答案');
      return '是又不是'; // 返回默认答案，但不使用本地分析器
    }
    
    // 在API调用失败时，尝试使用本地问题分析器
    try {
      // 获取谜题内容用于本地分析
      let puzzleContent = '';
      try {
        const currentPuzzle = localStorage.getItem('currentPuzzle');
        if (currentPuzzle) {
          const puzzleData = JSON.parse(currentPuzzle);
          puzzleContent = puzzleData.content || '';
        }
      } catch (e) {
        console.error('无法获取谜题内容:', e);
      }
      
      // 确保我们已经尝试过API调用
      if (apiCallCount > 0) {
        // 使用本地分析器
        return getLocalFallbackResponse(question, puzzleContent);
      } else {
        // 如果我们甚至没有尝试过API调用，返回默认答案
        return '是又不是';
      }
    } catch (fallbackError) {
      console.error('本地分析器也失败:', fallbackError);
      
      // 在所有方法都失败时，返回默认答案
      return '是又不是';
    }
  }
};

// 获取可用的AI模型
export const getAvailableModels = () => {
  return [
    { id: 'qwen/qwen3-1.7b:free', name: 'Qwen 3', canRemove: false },
    { id: 'openai/gpt-4o-mini', name: 'GPT-4o mini', canRemove: true },
    { id: 'anthropic/claude-3-haiku', name: 'Claude Haiku', canRemove: true },
    { id: 'mistralai/mistral-7b-instruct', name: 'Mistral', canRemove: true }
  ];
};

// 获取API调用状态信息
export const getApiCallStatus = () => {
  return {
    callCount: apiCallCount,
    lastCallTime: lastApiCallTime ? new Date(lastApiCallTime).toISOString() : null,
    successful: apiCallSuccess,
    inProgress: apiCallInProgress
  };
};

// 添加以下函数
export const getPuzzleById = async (id) => {
  // 模拟从服务器获取谜题数据
  // 在实际项目中，这里应该是一个API调用
  
  // 数据与首页和搜索页面保持一致
  const puzzles = [
    {
      id: 1,
      title: '消失的旅客',
      description: '一列火车穿过隧道，出来时少了一名乘客...',
      content: '一列火车正在行驶中，车上共有12名乘客。火车进入了一条隧道，当火车驶出隧道时，乘务员发现少了一名乘客。车门从始至终都是锁着的，窗户也无法打开，列车进出隧道前后没有停靠过站台。这名乘客是如何消失的？',
      solution: '这名乘客并没有真正消失，而是在隧道中因心脏病突发去世，被乘务员抬到了另一个车厢安置，所以看起来"少了一名乘客"。',
      creator: '谜语大师',
      date: '2025-02-28',
      cover: 'https://source.unsplash.com/random/600x600?mystery',
      difficulty: '中等',
      views: 1423,
      comments: 4,
      favorites: 128,
      category: '推理'
    },
    {
      id: 2,
      title: '奇怪的遗嘱',
      description: '富翁留下的遗嘱中只有一句话：向北走十步...',
      content: '一位富翁去世后，只留下一份奇怪的遗嘱，上面写着："向北走十步，向东走五步，向下挖三米，你将找到我的财富。"继承人按照指示做了，却什么也没找到。遗嘱中隐藏着什么秘密？',
      solution: '遗嘱中提到的不是实际的方向，而是钢琴键。"北"代表黑键，"东"代表白键，"下"代表低音部。富翁的财宝藏在他的老式钢琴内部。',
      creator: '推理迷',
      date: '2025-02-25',
      cover: 'https://source.unsplash.com/random/600x600?puzzle',
      difficulty: '困难',
      views: 987,
      comments: 4,
      favorites: 93,
      category: '解谜'
    },
    {
      id: 3,
      title: '雨夜里的陌生人',
      description: '暴雨中，一个陌生人敲开了独居老人的门...',
      content: '一个雷雨交加的夜晚，一位独居老人听到有人敲门。门外站着一个浑身湿透的陌生人，说他的车在附近抛锚了，想借用电话。老人让他进来后，给了他毛巾和热茶，但拒绝给他使用电话。为什么？',
      solution: '老人家里根本没有电话。这个细节暗示了老人可能住在一个非常偏远的地方，或者他选择与外界隔绝的生活方式。',
      creator: '故事控',
      date: '2025-04-21',
      cover: 'https://source.unsplash.com/random/600x600?night',
      difficulty: '简单',
      views: 1532,
      comments: 4,
      favorites: 215,
      category: '悬疑'
    },
    // 其他谜题...
  ];
  
  // 通过ID查找对应的谜题
  const puzzle = puzzles.find(p => p.id === parseInt(id));
  
  // 如果找不到，抛出错误
  if (!puzzle) {
    throw new Error(`找不到ID为${id}的谜题`);
  }
  
  return puzzle;
};

// 导出当前API Key信息
export const getApiKeyInfo = () => {
  const currentIndex = getCurrentKeyIndex();
  return {
    currentIndex: currentIndex,
    total: API_KEYS.length,
    displayText: `API Key ${currentIndex + 1}/${API_KEYS.length}`
  };
}; 